// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer__footer___k9XhS{border-top:.5px solid #e9eff5;display:flex;justify-content:center;align-items:center;height:25px;flex-shrink:0;font-size:10px;font-weight:500;color:#717070}.footer__footerNavigation___2cOtA{display:flex;height:40px;justify-content:space-around;align-items:center;cursor:pointer}.footer__icon___cjPgj{width:18px;height:18px;margin:0 10px 0 0}.footer__itemContainer___3Rf1q{display:flex;width:50%;align-items:center;justify-content:center;color:#717070;border-top:.5px solid #e9eff5;height:100%}.footer__itemContainer___3Rf1q:hover{color:var(--primary-button-background-color)}.footer__highlighted___2CfPB{border-top:1px solid var(--primary-button-background-color);color:var(--primary-button-background-color);background-color:#fff}.footer__chatContainer___3qQvm{position:relative}.footer__unread___RtBLR{height:10px;width:10px;min-width:10px;background-color:red;position:absolute;top:-2px;right:-10px}.footer__footerContainer___1nexL{margin-top:auto}html[dir=\"rtl\"] .footer__icon___cjPgj{margin:0 0 0 10px;transform:scaleX(-1)}html[dir=\"rtl\"] .footer__unread___RtBLR{left:-10px;right:initial}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"footer": "footer__footer___k9XhS",
	"footerNavigation": "footer__footerNavigation___2cOtA",
	"icon": "footer__icon___cjPgj",
	"itemContainer": "footer__itemContainer___3Rf1q",
	"highlighted": "footer__highlighted___2CfPB",
	"chatContainer": "footer__chatContainer___3qQvm",
	"unread": "footer__unread___RtBLR",
	"footerContainer": "footer__footerContainer___1nexL"
};
module.exports = exports;
